<template>
  <v-app>
    <transition v-if="loading" name="fade" appear>
      <lottie-loader
        :options="defaultOptions"
        @animComplete="animComplete"
        v-on:animCreated="handleAnimation"
      />
    </transition>

    <span
      v-if="environment == 'development'"
      class="ml-5 font-weight-bold development"
      >DEVELOPMENT</span
    >

    <mobile-menu v-if="!loading && user" @logOut="logOut()" />
    <v-snackbar top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>

    <transition name="fade" appear>
      <div id="loading" v-if="$store.state.loading || loading">
        <div>
          <lottie
            :options="defaultOptions"
            :height="120"
            :width="200"
            v-on:animCreated="handleAnimation"
          />
          <span class="loadingText">{{ $store.state.loadingText }}</span>
        </div>
      </div>
    </transition>

    <div class="d-none d-sm-none d-md-block d-lg-block">
      <transition name="appear" appear>
        <div id="nav" v-if="$store.state.navBar && !loading">
          <svg
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.20993 25.1583C9.45901 26.6345 12.0905 27.421 14.7808 27.4212L14.7473 27.4373C15.8507 27.434 16.9496 27.2975 18.0203 27.0309C18.1293 27.0048 18.2384 26.9776 18.345 26.9478C20.1381 26.4603 21.815 25.6174 23.2761 24.4692C24.8965 23.1609 26.1685 21.4726 26.9791 19.5542C28.2655 16.5117 28.3634 12.8819 27.1192 9.80593C26.7852 8.98593 26.3511 8.21043 25.8266 7.49712L25.8179 7.48597C24.909 6.27643 23.6941 5.33103 22.2983 4.74713C22.2202 4.71243 22.1385 4.68021 22.0579 4.65047C21.5978 4.47809 21.1228 4.34866 20.6389 4.26381C20.019 4.15461 19.3885 4.1176 18.7601 4.15351H18.7539C18.5891 4.16219 18.433 4.17706 18.2768 4.19441C15.1575 4.51167 13.2465 6.22437 12.5562 7.17863C12.4385 7.34097 12.2762 7.83049 12.5699 8.206C12.6659 8.34125 12.8014 8.4435 12.9578 8.49875C13.1142 8.55399 13.2839 8.55952 13.4436 8.51458C15.1414 7.99284 17.2333 8.43155 18.7044 10.0389C19.3799 10.7775 19.8307 11.6934 20.004 12.6792C20.1772 13.665 20.0656 14.6797 19.6823 15.6043C19.2989 16.5289 18.6598 17.325 17.8399 17.8991C17.02 18.4731 16.0533 18.8014 15.0534 18.8453H14.5825C13.3516 18.7896 12.1836 18.2858 11.2984 17.4288C8.55456 14.8151 8.39841 10.257 9.98718 7.01876C10.1235 6.72876 10.2735 6.44992 10.4333 6.18223C10.4333 6.18223 12.0816 3.4719 15.1426 2.37017C15.1426 2.37017 15.6768 2.1756 16.0325 2.09009C16.3881 2.00458 16.693 1.65138 16.6521 1.26348C16.6013 0.795027 16.3733 0.526101 15.8862 0.414564C15.6012 0.348882 14.927 0.357556 14.6308 0.357556C11.0503 0.356167 7.6129 1.76354 5.06142 4.27559C2.50995 6.78764 1.04923 10.2027 0.994873 13.7828C1.01798 16.0434 1.59714 18.2636 2.68125 20.2475C3.76535 22.2314 5.32108 23.9179 7.21116 25.1583H7.20993ZM17.3114 7.7078C16.2109 8.07959 15.129 7.80571 14.8923 7.07824C14.8852 7.06306 14.8809 7.04666 14.8799 7.02991C14.6891 6.31608 15.4004 5.48699 16.486 5.14495C17.532 4.80786 18.5408 5.02102 18.8531 5.65305C18.8734 5.69289 18.8904 5.73434 18.9039 5.77698C19.1406 6.50197 18.4156 7.36824 17.3151 7.71648L17.3114 7.7078ZM20.8632 7.44135C20.5992 7.47977 20.3675 7.36824 20.3415 7.20217C20.3323 7.15468 20.3416 7.10546 20.3675 7.06461C20.4118 6.99493 20.4714 6.93635 20.5419 6.89338C20.6124 6.8504 20.6918 6.82419 20.774 6.81675C20.8521 6.80177 20.9325 6.80329 21.0099 6.82122C21.0874 6.83914 21.1603 6.87308 21.2238 6.92085C21.2626 6.95632 21.2879 7.004 21.2957 7.05593C21.3131 7.222 21.1321 7.40542 20.8632 7.44135ZM19.3488 5.70634C19.3463 5.68576 19.3463 5.66496 19.3488 5.64438C19.3637 5.27259 19.8321 4.99127 20.391 4.99127H20.4976C20.6786 4.99324 20.8571 5.03332 21.0215 5.10891C21.1859 5.1845 21.3326 5.29391 21.4519 5.42998C21.5307 5.53328 21.5679 5.66244 21.556 5.79186C21.5114 6.1971 21.0231 6.46975 20.4072 6.43133C19.8222 6.38672 19.3723 6.05954 19.3488 5.70263"
              fill="#FF1744"
            />
          </svg>

          <div class="linkContainer" @mouseleave="tooltip = false">
            <router-link
              @mouseover.native="showTooltip($event, 'Nuevo Mandado')"
              @click.native="tooltipOnActive = true"
              id="menu"
              to="/menu"
            >
              <v-icon>fas fa-plus</v-icon>
            </router-link>

            <router-link
              @mouseover.native="showTooltip($event, `Histórico de Órdenes`)"
              @click.native="tooltipOnActive = true"
              to="/tracking/1"
            >
              <v-icon>far fa-list-ol</v-icon>
            </router-link>

            <router-link
              v-if="user.role == 'admin'"
              @mouseover.native="showTooltip($event, 'Métodos de pago')"
              @click.native="tooltipOnActive = true"
              to="/payment-methods"
            >
              <v-icon>far fa-credit-card</v-icon>
            </router-link>

            <router-link
              v-if="user.role == 'admin'"
              @mouseover.native="showTooltip($event, 'Puntos permitidos')"
              @click.native="tooltipOnActive = true"
              to="/points"
            >
              <v-icon>fas fa-map-marked-alt</v-icon>
            </router-link>

            <router-link
              v-if="user.role == 'admin'"
              @mouseover.native="showTooltip($event, 'Configuraciones')"
              @click.native="tooltipOnActive = true"
              to="/settings"
            >
              <v-icon>far fa-cog</v-icon>
            </router-link>
          </div>

          <a
            class="logout"
            @click="logOut()"
            @mouseover="showTooltip($event, `Cerrar sesión`)"
            @mouseleave="tooltip = false"
          >
            <i class="far fa-sign-out-alt"></i>
          </a>
          <div
            class="navTooltip"
            ref="navTooltip"
            :class="{ active: tooltipOnActive, logout: tooltipOnLogout }"
            v-if="tooltip"
            :style="{ top: tooltipY }"
          >
            {{ tooltipText }}
          </div>
        </div>
      </transition>
    </div>

    <transition-page v-if="!loading">
      <router-view class="main-page" />
    </transition-page>
  </v-app>
</template>

<script>
import TransitionPage from "./components/TransitionPage";

import Lottie from "@/components/Lottie";
import lottieLoader from "@/components/lottie-loader";
import * as animationData from "@/assets/load3.json";
import { db, fb } from "@/firebase";
import { mapActions, mapState } from "vuex";
// import "leaflet/dist/leaflet.css";
import mobileMenu from "@/components/mobile-menu";

export default {
  name: "App",
  components: {
    TransitionPage,
    lottie: Lottie,
    mobileMenu,
    lottieLoader,
  },
  data() {
    return {
      user: null,
      debugMenuEnabled: false,
      navigationVisible: true,
      tooltip: false,
      tooltipY: "20px",
      tooltipText: "texto de prueba",
      tooltipOnActive: false,
      tooltipOnLogout: false,
      business: {},
      anim: null,
      snackbarText: "",
      snackbar: false,
      animationCompleted: false,
      loading: true,
      animationSpeed: 1.1,
      defaultOptions: {
        animationData: animationData.default,
        loop: true,
        autoplay: true,
      },
    };
  },
  computed: {
    ...mapState(["search", "searchTerm", "searchLabel"]),

    environment() {
      return process.env.NODE_ENV;
    },

    setSearchTerm: {
      get() {
        return this.searchTerm;
      },
      set(e) {
        this.updateSearchTerm(e);
      },
    },
  },
  mounted() {
    fb.auth().onAuthStateChanged((authUser) => {
      if (authUser) {
        this.$binding("user", db.collection(`appUsers`).doc(authUser.uid))
          .then(async (user) => {
            // aqui se valida si el usuario tiene permisos para ingresar a la plataforma
            if (user.type != "cargo") {
              this.snackbarText = `Este perfíl de usuario no tiene permitido ingresar a la plataforma`;
              this.snackbar = true;

              this.logOut();
            } else {
              this.$store.commit("setUser", user);
              const t = await this.$binding(
                "business",
                db.collection(`businessesCorporative`).doc(user.businessID)
              );
              if (this.$router.currentRoute.name == "Login") {
                this.$router.push({ path: "/tracking/1" }).catch((err) => {});
              }
            }
            if (this.animationCompleted) {
              this.loading = false;
            }
          })
          .catch((err) => {
            this.logOut();
            console.log(err);
            this.snackbarText = `Este perfíl de usuario no tiene permitido ingresar a la plataforma`;
            this.snackbar = true;
          });
      } else {
        this.loading = false;
        this.$router.push({ path: "/" }).catch((err) => {});
      }
    });
  },
  watch: {
    user() {
      this.$store.commit("setUser", this.user);
    },
    animationCompleted(e) {
      if (e) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      }
    },

    // loading(value) {
    //   if (this.animationCompleted) {

    //   }
    // },
  },
  methods: {
    ...mapActions(["updateSearchTerm"]),
    animComplete() {
      this.animationCompleted = true;
    },
    logOut() {
      fb.auth()
        .signOut()
        .then(() => {
          this.$store.commit("setUser", null);
          // Sign-out successful.
        })
        .catch(function (error) {
          // An error happened.
        });
    },
    handleAnimation: function (anim) {
      this.anim = anim;
      anim.setSpeed(this.animationSpeed);
    },
    showTooltip(e, text) {
      this.tooltipText = text;
      if (e.srcElement.classList.contains("router-link-exact-active")) {
        this.tooltipOnActive = true;
        this.tooltipOnLogout = false;
        this.tooltipY = `calc( ${
          e.srcElement.getBoundingClientRect().top
        }px - 9px) `;
      } else if (e.srcElement.classList.contains("logout")) {
        this.tooltipOnActive = false;
        this.tooltipOnLogout = false;
        this.tooltipY = `calc( ${
          e.srcElement.getBoundingClientRect().top
        }px - 11px) `;
      } else {
        this.tooltipOnActive = false;
        this.tooltipOnLogout = false;
        this.tooltipY = `calc( ${
          e.srcElement.getBoundingClientRect().top
        }px - 11px) `;
      }
      this.tooltip = true;
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/brands.scss";
@import "~@/assets/scss/fontawesome.scss";
@import "~@/assets/scss/light.scss";
@import "~@/assets/scss/regular.scss";
@import "~@/assets/scss/solid.scss";

@import url("https://fonts.googleapis.com/css2?family=Ubuntu+Mono:wght@400;700&display=swap");

@font-face {
  font-family: "nexa";
  src: url("~@/assets/fonts/nexa_regular-webfont.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "nexa";
  src: url("~@/assets/fonts/nexa_light-webfont.woff2") format("woff2");
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "nexa";
  src: url("~@/assets/fonts/nexa_bold-webfont.woff2") format("woff2");
  font-weight: bold;
  font-style: normal;
}

.mono {
  font-family: "Ubuntu Mono", monospace !important;
}

* {
  padding: 0;
  margin: 0;
  font-family: "nexa";
}

body {
  background: #f1f4f8;
  background: radial-gradient(#d2d5df 0px, #f1f4f8 1px);
  background-size: 10px 10px;

  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

::-webkit-resizer {
  background: #FF1744;
  border-radius: 10px;
  position: absolute;
  width: 3px;
  box-shadow: 0px 0px 10px rgba(#FF1744, 0.9);
}

.appear-enter-active,
.appear-leave-active {
  transition: transform 0.4s cubic-bezier(0.44, 0.1, 0.28, 1.59);
}
.appear-enter,
.appear-leave-to {
  transform: translateX(-100px);
}

.appear-far-enter-active,
.appear-far-leave-active {
  transition: transform 0.4s cubic-bezier(0.44, 0.1, 0.28, 1.59);
}
.appear-far-enter,
.appear-leave-to {
  transform: translateX(-40vw);
}

.appear-reverse-enter-active,
.appear-reverse-leave-active {
  transition: transform 0.4s cubic-bezier(0.44, 0.1, 0.28, 1.59);
}
.appear-reverse-enter,
.appear-reverse-leave-to {
  transform: translateX(30vw);
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s;
}
.slide-enter,
.slide-leave-to {
  max-height: 0vh !important;
  // transform: scale(1, 0);
  transform-origin: top left;
}

.pointContainer {
  transition: all 0.3s;
  // display: inline-block;
  // margin-right: 10px;
}
.popIn-enter, .popIn-leave-to
/* .popIn-leave-active below version 2.1.8 */ {
  opacity: 0;
  // transition-delay: 0;
  transform: scale(0, 0);
}
.popIn-leave-active {
  position: absolute;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #00cdbc;
}

#loading {
  position: absolute;
  z-index: 9998;

  width: 100vw;
  height: 100vh;
  background: rgba(rgba(17, 17, 17, 0.48), 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  pointer-events: none;

  top: 0;
  left: 0;
  & > div {
    background: rgba(#fff, 1);
    filter: drop-shadow(0px 0px 50px rgba(#000000, 0.2));
    width: 240px;
    height: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 25px;
  }

  & > div > div {
    object-fit: cover;
    object-position: center;
    overflow: visible !important;
  }
  .loadingText {
    color: #111;
    font-weight: 900;
    pointer-events: none;
  }
}

#nav {
  padding: 10px;
  position: absolute;
  box-sizing: border-box;
  border-radius: 35px;
  top: 10px;
  left: 10px;
  height: calc(100vh - 20px);
  z-index: 2;
  background: white;
  filter: drop-shadow(0px 0px 20px rgba(#000000, 0.3));
  display: flex;
  justify-content: center;
  flex-direction: column;

  .navTooltip {
    position: absolute;
    font-weight: 900;
    padding: 5px 15px;
    border-radius: 18px;
    background: white;
    box-sizing: border-box;
    line-height: 32px;
    text-align: left;
    color: #FF1744;
    height: 42px;
    left: 76px;
    top: calc(50vh - 26px - 5px);
    white-space: nowrap;
    pointer-events: none;
    transition: 0.3s all;
    filter: none;

    &.active {
      background: #FF1744;
      filter: drop-shadow(0px 0px 20px rgba(#FF1744, 0.5));
      color: white;

      &::after {
        background: #FF1744;
      }
    }

    &.logout {
      background: #111;
      filter: drop-shadow(0px 0px 20px rgba(#111, 0.5));
      color: white;
      font-size: 30px;

      &::after {
        background: #111;
      }
    }

    &::after {
      content: "";
      position: absolute;
      background: white;
      width: 20px;
      height: 20px;
      left: -4px;
      top: 21px;
      margin-top: -10px;
      transform: rotate(45deg);
      border-radius: 4px;
      z-index: -1;
      transition: 0.3s all;
    }
  }

  svg {
    position: absolute;
    top: 20px;
    width: 50px;
    left: 15px;

    path {
      fill: #FF1744;
    }
  }

  .avatar {
    position: absolute;
    top: 60px;
    border-radius: 18px;
    left: 10px;
    width: 42px;
  }

  a {
    font-weight: bold;
    color: #aaa;
    text-decoration: none;
    display: block;
    margin: 10px;
    padding: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    // flex-direction: column;
    // position: relative;
    transition: 0.3s all;
    align-items: center;

    & > * {
      pointer-events: none;
    }

    i {
      font-size: 21px;
    }

    &.logout {
      position: absolute;
      bottom: 0;
      left: 5px;
      color: white;
      background-color: #111;
      padding: 5px;
      width: 50px;
      height: 50px;
      box-shadow: 0px 0px 0px rgba(#111, 0.8);
      transition: 0.3s all;

      &:hover {
        box-shadow: 0px 0px 20px rgba(#111, 0.8);
      }
    }

    &.debugActive {
      color: #FF1744;
      background-color: white;
      box-shadow: 0px 0px 10px rgba(#333, 0.2);
    }

    &.router-link-exact-active {
      color: white;
      background-color: #FF1744;
      transform: scale(1.1, 1.1);
      box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);

      i {
        color: white !important;
      }
    }
  }
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 700px;
  border-radius: 15px;
  position: relative;
  text-align: center;
  margin-bottom: 10%;
}

.modal-btn {
  height: 10vh;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  right: 20px;
  top: 10px;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.calendar {
  background-color: #b1a4a426;
  padding: 15px;
  margin-right: 10px;
  color: black;
  border-radius: 20px;
}

tbody {
  color: black !important;
}

.daterangepicker .calendar-table td,
.daterangepicker .calendar-table th {
  color: black !important;
}

.btn-success {
  background-color: #FF1744 !important;
  color: white;
  cursor: pointer;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #95989b !important;
  border-color: transparent;
  color: #fff;
}

.vc-btn {
  color: red !important;
}

.vc-btn.left {
  background-color: transparent !important;
  color: black !important;
}

.leaflet-popup-content {
  margin: 15px 10px 15px 15px !important;
  width: 250px;
}

::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #909090;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb {
  background: #777777;
  border-radius: 5px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  max-width: 90px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #FF1744;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2a7cc0;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  max-width: 90px;
}

.slider.round:before {
  border-radius: 50%;
}

.v-card {
  border-radius: 20px !important;
}

.v-dialog {
  border-radius: 20px !important;
}

.v-snack__content {
  display: flex !important;
  justify-content: center !important;
}

.leaflet-popup-close-button {
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: 30px !important;
  }

  span:hover {
    color: white;
  }
}

.leaflet-popup-close-button:hover {
  color: white;
}

.leaflet-control-zoom.leaflet-bar a {
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.v-card__title {
  color: #00cdbc;
}

.trackingContainer {
  text-align: left;
  &.navBarActive {
    padding-left: 130px;
  }
}

.viewContainer {
  padding: 20px;
  padding-top: 0;
  transition: 0.3s all;
  box-sizing: border-box;
}

.searchGeo {
  appearance: none;
  border: none;
  outline: none;
  font-weight: bold;
  color: white;
  text-decoration: none;
  margin: 0 5px;
  box-sizing: content-box;
  text-align: center;
  width: 500px;
  border-radius: 18px;
  position: absolute;
  top: 20px;
  left: 50%;
  margin-left: -250px;
  transition: 0.4s 0s all cubic-bezier(0.44, 0.1, 0.28, 1.59);
  color: white;
  z-index: 2;
  left: calc(50% - 150px) !important;

  &::after {
    content: "Presiona ↵ para buscar";
    position: absolute;
    z-index: 2;
    color: #FF1744;
    text-align: right;
    font-size: 11px;
    line-height: 10px;
    width: 80px;
    // top: 11px;
    right: 16px;
    opacity: 0;
    transition: 0.3s all;
  }

  &:hover::after {
    opacity: 1;
  }

  input {
    appearance: none;
    border: none;
    outline: none;
    padding: 5px 40px;
    padding-left: 40px;
    padding-right: 90px;
    background: none;
    font-size: 14px;
    font-weight: 500;
    flex: 1;
    box-sizing: border-box;
    height: 100%;
    height: 42px;
    width: 100%;
    opacity: 0.9;
    border-radius: 18px;
    filter: drop-shadow(0px 0px 20px rgba(#000000, 0.3));
    background-color: #fff;
    transition: 0.3s all;
    color: #666;

    &:focus,
    &:hover {
      color: #111;
      filter: drop-shadow(0px 0px 20px rgba(#000000, 0.4));
      opacity: 1;
    }

    &::placeholder {
      color: #333;
      opacity: 0.6;
    }
  }

  i {
    top: 10px;
    left: 10px;
    position: absolute;
    color: #FF1744;
    z-index: 2;
    font-size: 21px;
    margin-right: 10px;
  }

  .matches {
    width: 100%;
    box-sizing: border-box;
    max-height: 50vh;
    overflow: hidden;
    color: #111;
    text-align: left;
    font-weight: normal;
    margin: 10px 0;
    background-color: white;
    border-left: 5px solid white;
    border-right: 5px solid white;
    border-radius: 18px;
    filter: drop-shadow(0px 0px 20px rgba(#000000, 0.3));

    ul {
      list-style: none;
      max-height: 50vh;
      overflow: hidden;
      overflow-y: scroll;
      overflow-x: hidden;
      color: black !important;

      &::-webkit-scrollbar {
        width: 1px;
      }

      &::-webkit-scrollbar-track {
        background: none;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #FF1744;
        border-radius: 10px;
        height: 10px;
      }

      li {
        padding: 5px 10px;
        padding-bottom: 10px;
        margin: 5px;
        font-size: 14px;
        box-sizing: border-box;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        cursor: pointer;

        i {
          color: #111;
          position: relative;
          top: 0;
          left: 0;
          margin-right: 5px;
          font-size: 16px;
          opacity: 0.2;
        }

        &:hover {
          color: #FF1744 !important;

          i {
            opacity: 1;
            color: #FF1744 !important;
          }
        }

        &:first-of-type {
          padding-top: 0px;
          margin-top: 20px;
        }

        &:last-of-type {
          padding-bottom: 0px;
          border-bottom: none;
          margin-bottom: 20px;
        }
      }
    }
  }
}

.sideBarActive {
  .leaflet-control-zoom {
    right: 405px !important;
    transition-delay: 0s;
    margin-right: 0;
  }
}

.leaflet-control-zoom {
  border: none;
  padding: 5px;
  right: 0;
  transition: 0.4s 0.1s all cubic-bezier(0.44, 0.1, 0.28, 1.59);

  &.leaflet-bar {
    box-shadow: none;
    border-radius: 0;

    a,
    a:hover {
      filter: drop-shadow(0px 0px 10px rgba(#FF1744, 0.8));
      font-family: "Font Awesome 5 Pro";
      font-style: normal;
      font-weight: 400;
      background-color: #FF1744;
      border-bottom: none;
      width: 28px;
      height: 28px;
      line-height: 28px;
      display: block;
      text-align: center;
      text-decoration: none;
      color: white;
      border-radius: 12px;
    }

    a:first-child {
      margin-bottom: 10px;
    }
  }
}

.leaflet-control-zoom-in,
.leaflet-control-zoom-out {
  font: bold 18px "Lucida Console", Monaco, monospace;
  text-indent: 1px;
}

.leaflet-touch .leaflet-control-zoom-in,
.leaflet-touch .leaflet-control-zoom-out {
  font-size: 22px;
}
.triggerPanel {
  appearance: none;
  cursor: pointer;
  border: none;
  outline: none;
  font-weight: bold;
  color: white;
  text-decoration: none;
  margin: 0 5px;
  box-sizing: content-box;
  text-align: center;
  padding: 5px;
  width: 32px;
  height: 32px;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
  transition: 0.4s 0.1s all cubic-bezier(0.44, 0.1, 0.28, 1.59),
    0.4s 0.5s transform cubic-bezier(0.44, 0.1, 0.28, 1.59);
  color: white;
  background-color: #FF1744;
  box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);
  z-index: 2;
  transform: rotate(180deg);

  &.sideBarActive {
    right: 410px;
    transition: 0.4s 0s all cubic-bezier(0.44, 0.1, 0.28, 1.59),
      0.4s 0.5s transform cubic-bezier(0.44, 0.1, 0.28, 1.59);
    transform: rotate(0deg);
  }

  &.inactive {
    background-color: #aaa;
    box-shadow: 0px 0px 20px rgba(#333, 0.2);
  }
  i {
    font-size: 21px;
  }
}

.vue2leaflet-map {
  z-index: 1;
}

.leaflet-popup-close-button span {
  font-size: 35px !important;
}

@media screen and (max-width: 992px) {
  .trackingContainer {
    &.navBarActive {
      padding-left: 0px;
      padding: 10px;
    }
  }

  .main-page {
    margin-top: 50px;
  }

  .modal {
    margin-top: 0;
    padding-top: 0;
  }
  .modal-content {
    border-radius: 5px;
    max-height: 70vh;
    overflow: hidden;

    .errands-container {
      max-height: 50vh;
      overflow: auto;
    }
  }
  .viewContainer {
    padding: 0;
  }

  .v-application {
    margin: 0 !important;
  }

  .header {
    display: flex !important;
    justify-content: flex-start !important;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .v-slide-group__prev {
    display: none !important;
  }

  .v-card__text {
    padding: 0 !important;
  }
  .searchGeo {
    left: 0 !important;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0 !important;
    width: 93%;
    position: fixed;
    top: 80px !important;

    &::after {
      content: "";
      display: none;
      // top: 40px;
    }

    input {
      padding-right: 40px !important;
    }
  }

  .modal-content {
    width: 100% !important;
    top: 0;
  }

  .tag {
    display: none;
  }

  .triggerPanel.sideBarActive {
    // right: 5px !important;
    // top: 10%;
    // z-index: 2;
    display: none;
  }

  .sideBarActive .leaflet-control-zoom {
    // right: 0 !important;
    display: none;
  }

  .leaflet-container a.leaflet-popup-close-button {
    z-index: 3 !important;
  }

  .v-dialog {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  @media (orientation: landscape) {
    .modal {
      margin-top: 0;
      padding-top: 0;
      height: 100vh;
      overflow: hidden;
    }

    .createBtn {
      height: 14vh !important;
    }

    .modal-content {
      width: 60vw !important;
      margin-top: 0;
      height: 100vh;
      max-height: 100vh;
      border-radius: 5px;
      padding: 0;

      .modal-title {
        height: 17vh;
        max-height: 17vh;
        overflow: hidden;
        padding-top: 15px;
        h2 {
          font-size: 18px;
          text-align: start;
        }
      }

      .modal-btn {
        height: 18vh;
        min-height: 18vh;
        max-height: 18vh;
        padding: 0px 15px 0 15px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .errands-container {
        max-height: 65vh;
        overflow-y: auto;
        padding: 15px;
      }
    }
  }
}

.leaflet-control-geosearch form input {
  height: 40px !important;
}
.leaflet-touch .leaflet-control-geosearch a.reset {
  font-size: 20px;
  font-weight: bold;
  margin-top: 5px;
}

.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  border: 0 !important;
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #FF1744;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 25%;
    animation: hideshow 2s ease infinite;
  }
}

@keyframes hideshow {
  0% {
    transform: scale(1, 1);
  }

  50% {
    transform: scale(1.2, 1.2);
  }

  100% {
    transform: scale(1, 1);
  }
}

// .v-navigation-drawer__content {
//   height: 100vh!important;
// }

.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close),
.v-navigation-drawer--temporary:not(.v-navigation-drawer--close) {
  height: 100vh !important;
}

.mapContainer-errand {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
@media screen and (max-width: 992px) {
  .mapContainer-errand {
    top: 0;
    max-height: 100vh;
    overflow: hidden;
    position: absolute;
  }

  .v-dialog {
    margin-top: 70px !important;
    border-radius: 0 !important;
  }

  .v-card {
    border-radius: 0 !important;
  }

  .v-card__title {
    position: sticky;
    top: 0;
    background-color: white !important;
    z-index: 2;
  }

  .v-card__actions {
    position: sticky !important;
    bottom: 0;
    z-index: 2;
    background-color: white;
  }

  .v-dialog__content {
    // display: flex!important;
    // align-items: flex-start!important;
  }
}

.createBtn {
  z-index: 2;
  position: fixed;
  bottom: 0vh;
  display: grid;
  padding: 0 10px 0 10px;
  grid-template-columns: 65% 35%;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 10vh;
  background-color: #ffffffe5;
  box-shadow: 0px 5px 5px rgb(205, 205, 205),
    0px -5px 5px rgba(136, 136, 136, 0.37);
}

.development {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 1.2vw;
}
</style>

